import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PasswordLogin.css";
import Layout from "../../Layout.jsx";
import { useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";

const USERS_BASE_URL = import.meta.env.VITE_USERS_BASE_URL;
const SITE_NAME = import.meta.env.VITE_SITE_NAME;

const PasswordLogin = () => {
  const location = useLocation();
  const emailFromState = location.state?.email || "";

  const [email, setEmail] = useState(emailFromState);
  const [step, setStep] = useState(emailFromState ? 2 : 1);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email is required");
      return;
    }
    setStep(2);
    setError("");
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email is missing. Please go back and enter it again.");
      return;
    }
    try {
      const response = await fetch(`${USERS_BASE_URL}/api/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        email,
          password
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        const { access, refresh } = data;
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);
        navigate("/dashboard");
      } else {
        if (data.non_field_errors?.includes("Please verify your email before logging in.")) {
        setError("Email not verified. Sending verification code...");
        try {
            const verifyResponse = await fetch(`${USERS_BASE_URL}/resend-verification/`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ 
                email, 
                site_name: SITE_NAME 
              })
            });
            
            if (verifyResponse.ok) {
          setError("Email not verified. Verification code sent. Redirecting...");
          setTimeout(() => {
            navigate("/verify-otp", {
              state: {
                email,
                purpose: "verification",
              },
            });
          }, 2000);
            } else {
              setError("Failed to send verification code. Please try again.");
            }
        } catch (verificationErr) {
          setError("Failed to send verification code. Please try again.");
        }
        return;
        }
        setError(data.detail || data.error || "Login failed");
      }
    } catch (error) {
        setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="password-container">
      <img src={logo} alt="App Logo" className="logo" />
      <h2>{step === 1 ? "Enter Email" : "Enter Password"}</h2>

      {step === 1 && (
        <form onSubmit={handleEmailSubmit}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Next</button>
        </form>
      )}

      {step === 2 && (
        <form autoComplete="off" onSubmit={handlePasswordSubmit}>
          <p>
            Email: <strong>{email}</strong>
          </p>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <button type="submit">Login</button>
          <p className="text-center mt-2">
            <span
              className="link"
              onClick={() => {
                if (email) {
                  navigate("/verify-otp", {
                    state: {
                      email,
                      purpose: "password_reset",
                    },
                  });
                } else {
                  alert("Please enter your email first.");
                }
              }}
            >
              Forgot Password?
            </span>
          </p>
        </form>
      )}

      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default PasswordLogin;
